<template>
    <HighlightComponent />
</template>

<script lang="ts" setup>
import type { VNode } from 'vue'

import { h, useCssModule } from 'vue';

const props = defineProps({
    value: {
        type: String,
        required: true,
    },

    search: {
        type: String,
        required: true,
    },
});

const $style = useCssModule()

const HighlightComponent = (): VNode => {
    const value = props.value
        .replace(/(^\w+:|^)\/\//, '')
        .replace(/^\/|\/$/g, '')

    if (props.search === '') {
        return h('span', value)
    }

    const pattern = props.search.replace(/([.+*?[^\]$(){}=!<>|:])/g, '\\$1')
    const match = value.split(new RegExp(`(${pattern})`, 'gi'))

    if (match.length === 1) {
        return h('span', value)
    }

    const nodes: VNode[] = []

    match.forEach((_, key) => {
        if (key % 2) {
            nodes.push(h('span', { class: [$style.selected] }, match[key]))
        } else {
            nodes.push(h('span', match[key]))
        }
    })

    return h('span', nodes)
}

</script>

<style lang="less" module>
@import (reference) "@omnica/base/assets/stylesheets/palette.less";

.selected {
    background: @yellow-200;
}
</style>
